/** Beta User Access gate storage helpers (shared password unlock). */

export const STORAGE_KEY = 'xlog3d_tester_unlocked';
export const PROFILE_KEY = 'xlog3d_tester_profile';
export const UNLOCK_TTL_MS = 24 * 60 * 60 * 1000;

export const isUnlockValid = () => {
  const ts = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
  if (!ts) return false;
  return Date.now() - ts < UNLOCK_TTL_MS;
};

export const getTesterProfile = () => {
  if (!isUnlockValid()) return null;
  try {
    const raw = sessionStorage.getItem(PROFILE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || !p.email) return null;
    return {
      name: p.name || '',
      email: p.email,
      organization: p.organization || '',
      country: p.country || '',
    };
  } catch {
    return null;
  }
};

export const clearTesterUnlock = () => {
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(PROFILE_KEY);
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(PROFILE_KEY);
};

export const saveTesterUnlock = (profile) => {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  sessionStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
};
